import { ColorCalculationHelper } from "../../../library/helpers/ColorCalculationHelper";
import StringHelper from "../../../library/helpers/StringHelper";
import { HesapSarkiSesKayitNotlarModel } from "../../../models/businessModels/HesapSarkiSesKayitNotlarModel";
import type { PdfCanvasColorMeaning, PdfCanvasPoint } from "./pdfCanvasTypes";

export function parseNotKoordinat(koordinat: string | null): PdfCanvasPoint | null {
    if (!koordinat) {
        return null;
    }

    try {
        const parsed = JSON.parse(koordinat) as { x?: number, y?: number };
        if (typeof parsed.x === "number" && typeof parsed.y === "number") {
            return { x: parsed.x, y: parsed.y };
        }
    }
    catch {
        return null;
    }

    return null;
}

export function getEnYakinLegendAciklama(
    renkKod: string | null,
    legendItems: PdfCanvasColorMeaning[],
): string {
    if (!renkKod || legendItems.length === 0) {
        return legendItems[0]?.label ?? "";
    }

    return legendItems
        .orderBy(e => ColorCalculationHelper.RenkRgbMesafeKare(renkKod, e.color))
        .first()
        .label;
}

export function getHataNotDotTooltip(
    not: HesapSarkiSesKayitNotlarModel,
    legendItems: PdfCanvasColorMeaning[],
): string {
    return StringHelper.isNotEmpty(not.yorumlar)
        ? not.yorumlar!
        : getEnYakinLegendAciklama(not.renkKod, legendItems);
}
